import { IMAGE_EXTENSIONS } from '../files/constants';
import { getFileComponents } from '../getFileComponents';

export class DocumentViewUIHelper {
  static EXTENSIONS_ALLOWED_TO_SHOW_PREVIEW = [
    ...IMAGE_EXTENSIONS,
    'pdf',
    'xls',
    'csv',
    'xlsx',
    'docx',
    'doc',
  ];

  static shouldShowOpenInNewTab(extension: string) {
    const { extension: fileExtension } = getFileComponents(extension);

    return IMAGE_EXTENSIONS.includes(fileExtension) || fileExtension === 'pdf';
  }

  static shouldShowPreview(extension: string) {
    const { extension: fileExtension } = getFileComponents(extension);

    return this.EXTENSIONS_ALLOWED_TO_SHOW_PREVIEW.includes(fileExtension);
  }
}
